export default "__VITE_ASSET__CLWhZrVi__"